// angular
//     .module("HeroPRO")
//     .factory("KBYGFactory", KBYGFactory);

/* @ngInject */
export default function KBYGFactory(HPConfig, $http, $q) {
    const propertyTypes = [{ id: 1, value: 'Single Family Home' },
        { id: 2, value: 'Multi-family Home' },
        { id: 3, value: 'Mobile Home' },
        { id: 5, value: 'Town Home' },
        { id: 6, value: 'Condominium' }];

    const directions = [{ text: 'N/A', value: '' },
        { text: 'North', value: 'N' },
        { text: 'South', value: 'S' },
        { text: 'East', value: 'E' },
        { text: 'West', value: 'W' }];

    const suffixes = ['N/A',
				   'AVE',
				   'BLV',
				   'CIR',
				   'CT',
				   'CTR',
				   'CYN',
				   'DR',
				   'EXY',
				   'HWY',
				   'LN',
				   'MNR',
				   'PKY',
				   'PL',
				   'RD',
				   'RT',
				   'SQ',
				   'ST',
				   'TER',
				   'TR',
				   'WAY'];

    //	var states = [
    //		{
    //			'Name': 'California',
    //			'Code': 'CA'
    //		}
    //	];

    return {
        getPropertyType,
        getSalesReps,
        getTypeaheadSalesReps,
        getTypeaheadCompany,
        getContractorLocations,
        getDirections,
        getStreetSuffixes,
        submitZipcode,
        submit,
        getOneAppLink
    };

    function getPropertyType() {
        const deferred = $q.defer();
        deferred.resolve(propertyTypes);
        return deferred.promise;
    }

    function getSalesReps(contractorId, elevatedAccess) {
        return $http({
            url: `${HPConfig.heroProApi}ContractorUser`,
            method: 'GET',
            params: {
                ContractorLocationIds: contractorId,
                FilterBySalesRep: elevatedAccess,
            },
        });
    }


    function getTypeaheadSalesReps(payload) {
        return $http({
            url: `${HPConfig.heroProApi}ContractorUser/SearchByOrganization`,
            method: 'GET',
            params: {
                Name: payload.SalesRepName,
                OrganizationId: payload.OrgId,
                PageSize: payload.PageSize,
            },
        });
    }

    function getTypeaheadCompany(params) {
        return $http.get(`${HPConfig.heroProApi}Organization/SearchContractorOrganizations`, {
            params,
        });
    }

    function getContractorLocations(payload) {
        return $http({
            url: `${HPConfig.heroProApi}Contractor/Locations`,
            method: 'GET',
            params: {
                ContractorUserId: payload.ContractorUserId,
                OrganizationId: payload.OrganizationId,
            },
        });
    }

    function getDirections() {
        const deferred = $q.defer();
        deferred.resolve(directions);
        return deferred.promise;
    }

    function getStreetSuffixes() {
        const deferred = $q.defer();
        deferred.resolve(suffixes);
        return deferred.promise;
    }

    function submitZipcode(params) {
        return $http({
            url: `${HPConfig.heroProApi}Geo/Search`,
            method: 'POST',
            data: params,
        });
    }

    function submit(params) {
        return $http({
            url: `${HPConfig.heroProApi}KBYG/ContractorLead`,
            method: 'POST',
            data: params,
        });
    }

    function getOneAppLink (contractorLocationId){
        let params = {
            "request.contractorLocationId": contractorLocationId,            
            "request.getFinancingOptions": true
        };
        return $http.get(`${HPConfig.heroProApi}KBYG/OneAppUrl`, {
            params,
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/lead/kbyg/modal/KBYGFactory.js